import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import { GripVertical, X } from "lucide-react";

const DraggableSection = ({ id, index, children, onRemove, previewMode, sectionTitle, isHidden = false }) => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={{
            ...provided.draggableProps.style,
            cursor: 'default'
          }}
          className={`draggable-section ${isHidden ? "hidden-section" : ""} ${
            snapshot.isDragging ? "dragging" : ""
          }`}
        >
          <div 
            className="drag-handle" 
            {...provided.dragHandleProps}
          >
            <GripVertical size={30} />
          </div>
          {!previewMode && (
            <div className="section-actions">
            <button
              className="remove-section-btn"
              onClick={() => onRemove(id)}
              title="Remove section"
            >
              <X size={16} />
            </button>
            </div>
          )}
          {children}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableSection;
